import { AnimatedSection, ScrollAnimations } from "hooks/useScrollAnimations";
import BlackFridayBanner from "components/BannerBlackFriday";
import DestinationsCarousel from "components/DestinationsCarousel";
import HotelsCarousel from "components/HotelsCarousel";
import "../styles/Promotions.css";

const Promotions = () => {
  return (
    <ScrollAnimations>
      <div>
        <AnimatedSection className="promotions__banner">
          <BlackFridayBanner />
        </AnimatedSection>
      </div>

      <AnimatedSection className="fade-in">
        <DestinationsCarousel />
      </AnimatedSection>

      <AnimatedSection className="fade-in">
        <HotelsCarousel />
      </AnimatedSection>

      <div className="promotions__info">
        <ul className="promotions__list">
          <li>No tenemos servicios tercerizados</li>
          <li>
            Nuestros únicos medios de pago autorizados son:
            <ul className="promotions__sublist">
              <li>Número de cuenta de ahorros:Davivienda: 108900031627</li>
              <li>Cuenta corriente Bancolombia: 82900001108</li>
              <li>Cuenta corriente Davivi Bank: 4901016327</li>
              <li>Cuenta corriente Banco de Bogotá: 327297230</li>
            </ul>
          </li>
          <li className="promotions__nowrap">
            Pagos con tarjeta crédito y débito desde nuestra página web:
            www.elitevacances.com
          </li>
          <li className="promotions__nowrap">
            Nuestras líneas de atención son: +57 (1) 7945996, correo electrónico:
            sac@elitevacances.com
          </li>
          <li className="promotions__nowrap">
            Nos puedes ubicar en la Calle 93B # 17-25 Oficinas 309-310-311
            Edificio Centro Empresarial PH Bogotá, Colombia.
          </li>
        </ul>
      </div>
    </ScrollAnimations>
  );
};

export default Promotions;